import { api } from "./configs/axiosConfigs"

export const ProductsImportAPI = {

    getImportedProducts: async (data:any) => {
        const response = await api.get(
            '/productImport', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    ValidateUserImport: async () => {
        const response = await api.get(
            '/productImport/validateUser'
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    editImportedProduct: async (idproduct: number, data: any) => {
        const response = await api.post(
            `/productImport/update/${idproduct}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    saveImportedProduct: async (idproduct: number) => {
        const response = await api.post(
            `/productImport/import/${idproduct}`,
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    saveImportedProductMassive: async (data: any) => {
        const response = await api.post(
            '/productImport/importMassive', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },

    deleteImportedProduct: async (idproduct: number) => {
        const response = await api.delete(
            `/productImport/${idproduct}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}